import { useIntl } from 'react-intl';

import Footer from '@/components/footer/FooterWrapper';
import Redeem from '@/components/giftCard/Redeem';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest, useInitState } from '@/hooks/store';
import messages from '@/messages/messages';

const GiftCardPage = () => {
	useInitState({
		requests: [InitRequest.PRICES, InitRequest.USER, InitRequest.DEVICE],
	});
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="redeem" title={`Calm - ${formatMessage(messages.giftCardRedeemPageTitle)}`}>
			<Redeem />
			<Footer />
		</Layout>
	);
};

export default GiftCardPage;
